import { useState } from "react";

import api from "./api";
import { useUserSuperEmpresa } from "../Context/AuthContext";


export const useBuscarPaciente = () => {
     const { Token } = useUserSuperEmpresa();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const buscarPaciente = async (idPaciente) => {
    try {
      setLoading(true);
      setError(null);

      const res = await api.get(
        `/buscar-paciente/${idPaciente}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      
      setData(res.data);     // éxito
      return { ok: true, data: res.data };

    } catch (err) {
      if (err.response?.status === 404) {
        setError("Paciente no encontrado");
        return { ok: false, message: "Paciente no encontrado" };
      }

      setError("Error en el servidor");
      return { ok: false, message: "Error en el servidor" };
    } finally {
      setLoading(false);
    }
  };


  return {
    data,
    loading,
    error,
    buscarPaciente,
  };
};
